// Colours shared by the budget cards and the utilisation popup, so both follow the
// same light / dark theme.

const LIGHT = {
  ink: "#18302B",
  ink2: "#4E625D",
  ink3: "#7D8F8A",
  line: "#D5E0DC",
  line2: "#B9C9C4",
  head: "#F4F7F6",
  paper: "#FFFFFF",
  teal: "#0E9F86",
  tealDeep: "#0A6B5B",
  tealWash: "#E0F3EE",
  red: "#C2413A",
  redWash: "#FBE9E7",
  barBg: "#E7EEEC",
};

const DARK = {
  ink: "#E4EEEB",
  ink2: "#A9BAB5",
  ink3: "#7F918C",
  line: "#2A3835",
  line2: "#3B4C48",
  head: "#1D2A27",
  paper: "#172220",
  teal: "#2DBB9F",
  tealDeep: "#7FD9C5",
  tealWash: "#173B33",
  red: "#EF7D74",
  redWash: "#3F1F1C",
  barBg: "#24312E",
};

export const getBudgetCardColors = (isDarkMode) => (isDarkMode ? DARK : LIGHT);
